import { Component } from "react";
import * as React from "react";
import { Product } from "src/api/models/Product";

interface IProductCardProp {
    product: Product
}

export class ProductCard extends Component<IProductCardProp> {
    public render() {
        const prod = this.props.product;

        let textClass = "text";
        if (prod.soldOut) {
            textClass += " sold-out";
        }
        if (prod.new) {
            textClass += " new";
        }

        return (
            <div className="cell large-4 card product-carousel">
                <img src={prod.imgUrl} alt=""/>
                <div className={textClass}>
                    <p className="title">
                        {prod.title}
                        {prod.new ? <span className="flag new">NEU</span> : ""}
                        {prod.soldOut ? <span className="flag sold-out">Ausverkauft</span> : ""}
                    </p>
                    <p className="desc">{prod.desc}</p>
                    <hr/>
                    <p className="price">{prod.price.toFixed(2)} EUR</p>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/product/ProductCard.tsx